import styles from "./SectionMagazine.module.css";
import revista1 from "../../../assets/images/galeria/revista 1.png";
import revista2 from "../../../assets/images/galeria/revista 2.png";
import revista3 from "../../../assets/images/galeria/revista 3.png";

const SectionMagazine = () => {
  return (
    <section className={styles.section}>
      <div className={styles.title}>Ediciones Mayo 2025</div>
      <div className={styles.magazineGrid}>
        <img
          className={styles.magazineImage}
          src={revista1}
          alt="Edición 1"
          loading="lazy"
        />
        <img
          className={styles.magazineImage}
          src={revista2}
          alt="Edición 2"
          loading="lazy"
        />
        <img
          className={styles.magazineImage}
          src={revista3}
          alt="Edición 3"
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default SectionMagazine;
